<template>

    <div class="modal attendance-modal fade" id="newConversationModal" tabindex="-1"
         aria-labelledby="newConversationModal" aria-hidden="true" style="z-index:99999;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p class="text-lg mb-0 fw-semibold">Nieuw gesprek starten</p>
                    </div>
                    <button type="button" class="btn-close mb-0 me-0" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body pt-3 px-4 pb-3 mb-3">
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Type gesprek *</label>
                        <div class="employees-list d-flex gap-3">
                            <label class="employee flex-fill" role="button" @click.prevent="isInternal = false">
                                <div class="message-content">
                                    <div class="name text-sm fw-semibold">
                                        <input class="form-check-input" type="checkbox" :checked="isInternal === false" readonly>
                                        <div>
                                            Gesprek gekoppeld aan opdracht
                                        </div>
                                    </div>
                                </div>
                            </label>
                            <label class="employee flex-fill" role="button" @click.prevent="isInternal = true">
                                <div class="message-content">
                                    <div class="name text-sm fw-semibold">
                                        <input class="form-check-input" type="checkbox" :checked="isInternal === true" readonly>
                                        <div>
                                            Intern gesprek (niet gekoppeld aan opdracht)
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>

                    <!-- Title input for internal conversations -->
                    <div v-if="isInternal === true" class="mb-3">
                        <label class="form-label fw-semibold">Titel gesprek *</label>
                        <input type="text" class="form-control" v-model="conversationTitle" placeholder="Intern gesprek">
                    </div>

                    <!-- Search section - only show when NOT internal -->
                    <div v-if="isInternal === false" class="mb-3">
                        <label class="form-label fw-semibold">Koppel opdracht aan gesprek *</label>
                        <div class="mb-4 flex gap-2">
                            <div class="flex-grow">
                                <!-- Eerste rij met volledig breedte zoekveld -->
                                <div class="w-full mb-2">
                                    <input
                                        type="text"
                                        class="w-full form-control"
                                        v-model="searchQuery"
                                        :disabled="searchQueryZipCode.length > 0"
                                        placeholder="Zoek op dossier of opdracht #"
                                        v-on:keyup.enter="searchEntities()"
                                    >
                                </div>
                                <!-- Tweede rij met postcode en huisnummer -->
                                <div class="w-full flex gap-2">
                                    <div class="flex-1">
                                        <input
                                            type="text"
                                            class="w-full form-control"
                                            v-model="searchQueryZipCode"
                                            :disabled="searchQuery.length > 0"
                                            placeholder="Zoek op postcode"
                                        >
                                    </div>
                                    <div class="flex-1">
                                        <input
                                            type="text"
                                            class="w-full form-control"
                                            v-model="searchQueryHouseNo"
                                            :disabled="searchQuery.length > 0"
                                            placeholder="Zoek op huisnummer"
                                        >
                                    </div>
                                </div>
                            </div>
                            <!-- Zoekknop met volledige hoogte -->
                            <button
                                class="btn btn-outline-secondary h-full flex items-center justify-center"
                                type="button"
                                @click="searchEntities()"
                            >
                                <i class="fa fa-search"
                                   :class="{ 'fa fa-circle-o-notch fa-spin' : this.searchLoader }"></i>
                            </button>
                        </div>
                    </div>

                    <div v-if="searchResults.length > 0">
                        <label class="form-label fw-semibold">Resultaten</label>
                        <div class="list-group">
                            <a
                                v-for="result in searchResults"
                                href="#"
                                class="list-group-item list-group-item-action"
                                @click.prevent="selectOrder(result)"
                            >
                                <div class="w-full flex gap-2">
                                    <div>{{ result.item_dossier_nr }}</div>
                                    <div>{{ result.item_name }}</div>
                                    <div class="ms-auto">
                                        <small class="d-block text-muted">{{ result.item_status }}</small>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div v-if="selectedOrder && !isInternal" class="mt-3 order-select-container">
                        <span class="form-label fw-semibold">Geselecteerde opdracht #{{ selectedOrder.item_dossier_nr }} - {{
                                selectedOrder.item_name
                            }}</span>
                    </div>

                    <!-- End v-if="!isInternal" -->

                    <!-- First Message -->
                    <div class="my-3">
                        <label class="form-label fw-semibold">Bericht *</label>
                        <textarea
                            class="form-control conversation-message-input"
                            v-model="firstMessage"
                            rows="14"
                            placeholder="Schrijf hier je eerste bericht..."
                        ></textarea>
                    </div>

                    <!-- Users Selection -->
                    <div class="mb-0">
                        <label class="form-label fw-semibold">Gebruikers toevoegen</label>
                        <div class="employees-list" v-if="users.length > 0">
                            <label class="employee" v-for="user in users" :for="'user-' + user.id" role="button">
                                <div class="message-content">
                                    <div class="name text-sm fw-semibold">
                                        <input
                                            v-model="user.is_linked"
                                            type="checkbox"
                                            :id="'user-' + user.id"
                                            :disabled="user.id === currentUserId">
                                        <div>
                                            {{ user.name }}
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>


                    <div class="modal-body pt-0 px-4 pb-4 d-flex">
                        <button
                            class="btn btn-primary ms-auto px-3 py-2 text-sm"
                            @click="createConversation()"
                            :disabled="!canCreateConversation"
                        >
                            Gesprek starten <i class="fa fa-coffee"
                                               :class="{ 'fa fa-circle-o-notch fa-spin' : this.btnActionLoader }"></i>
                        </button>
                    </div>

                </div>

            </div>
        </div>
    </div>


</template>

<script>
import {EventBus} from "../../../event-bus";

export default {
    name: 'new-conversation-modal',
    data() {
        return {
            searchQuery: '',
            searchQueryZipCode: '',
            searchQueryHouseNo: '',
            searchResults: [],
            selectedOrder: null,
            firstMessage: '',
            users: [],
            currentUserId: null,
            searchLoader: false,
            btnActionLoader: false,
            isInternal: false,
            conversationTitle: '',
        }
    },
    computed: {
        canCreateConversation() {
            // For internal conversations, check title and message
            if (this.isInternal === true) {
                return this.conversationTitle.trim() !== '' &&
                    this.firstMessage.trim() !== '' &&
                    this.users.some(user => user.is_linked);
            }

            // For regular conversations, check order, message, and users
            return this.selectedOrder &&
                this.firstMessage.trim() !== '' &&
                this.users.some(user => user.is_linked);
        }
    },
    methods: {
        searchEntities() {
            if (this.searchQuery.trim() === '' && this.searchQueryZipCode.trim() === '') {
                this.searchResults = [];
                return;
            }

            this.searchLoader = true;

            axios.get('api/search-entities', {
                params: {
                    query: this.searchQuery,
                    queryZipCode: this.searchQueryZipCode,
                    queryHouseNo: this.searchQueryHouseNo
                }
            })
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true];
                    }
                    this.searchResults = response.data || [];
                    this.searchLoader = false;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het zoeken.", "error");
                    this.searchLoader = false;
                });
        },
        selectOrder(order) {
            this.selectedOrder = order;
            this.searchResults = [];
            this.searchQuery = '';
        },
        ensureCurrentUserIsLinked() {
            const currentUser = this.users.find(user => user.id === this.currentUserId);
            if (currentUser) {
                currentUser.is_linked = true;
            }
        },
        createConversation() {
            if (!this.canCreateConversation) {
                return;
            }

            this.btnActionLoader = true;

            this.ensureCurrentUserIsLinked();

            const selectedUsers = this.users.filter(user => user.is_linked);

            // Build payload based on conversation type
            const payload = {
                message: this.firstMessage,
                users: selectedUsers,
                isInternal: this.isInternal
            };

            if (this.isInternal) {
                payload.title = this.conversationTitle;
            } else {
                payload.orderId = this.selectedOrder.id;
                payload.type = this.selectedOrder.type;
            }

            axios.post('api/add-new-conversation', payload)
                .then(response => {
                    if (response.data.status === 422) {
                        this.modal.hide();
                        throw [true, response.data.message];
                    }

                    EventBus.$emit('refetchConversations');
                    this.resetForm();
                    this.btnActionLoader = false;

                    setTimeout(() => this.modal.hide(), 500);
                })
                .catch(e => {
                    this.btnActionLoader = false;
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het aanmaken van het gesprek.", "error");
                });
        },
        resetForm() {
            this.searchQuery = '';
            this.searchQueryZipCode = '';
            this.searchQueryHouseNo = '';
            this.searchResults = [];
            this.selectedOrder = null;
            this.firstMessage = '';
            this.isInternal = false;
            this.conversationTitle = '';
            // Reset user selection but keep the list
            this.users.forEach(user => {
                if (user.id !== this.currentUserId) {
                    user.is_linked = false;
                }
            });
        },
        loadUsers() {
            axios.get('api/get-all-users')
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    this.users = response.data.users;
                    this.currentUserId = response.data.currentUserId;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van gebruikers.", "error");
                });
        }
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('newConversationModal'));

        EventBus.$on('openNewConversationModal', () => {
            this.loadUsers();
            this.modal.show();
        });
    }
}
</script>
<style>
input.form-control {
    &:disabled {
        background: #f7f7f7;
    }
}

.order-select-container {
    padding: 1em;
    background-color: #F6BF40;
    border: 1px solid ##F6BF40;
    border-radius: 3px;
}
</style>
